module.exports = __webpack_public_path__ + "media/alcohol_training/alcohol_training_gray-5d93fe58.png";